export default __webpack_public_path__ + "static/frontend_bp_logo-7d5739e046c7fd8b55a2d72db05252a3.svg";